export const vendorReport = {
	title: "Informe delivery de vendors",
	sheet: {
		filename: "vendor-delivery-report",
		title: "Ventas delivery por vendor",
		columns: {
			vendor: "Vendor",
			value: "Valor",
			tip: "Propina",
			deliveryFee: "Tarifa de entrega",
		},
	},
	columns: {
		vendor: "Vendor",
		deliveryFee: "Tarifa de entrega",
		tip: "Propina",
		value: "Valor",
	},
};
